module.exports = __webpack_public_path__ + "img/project-progress.e528b571.svg";